import { PlanPaymentSuccess } from '../../../components/service/plan-payment';
export const SubscriptionPaymentsSuccessPageView = () => {
  return <PlanPaymentSuccess data-sentry-element="PlanPaymentSuccess" data-sentry-component="SubscriptionPaymentsSuccessPageView" data-sentry-source-file="SubscriptionPaymentsSuccessPageView.tsx" />;
};